export const CLOCK_UPDATE_DELAY = 1000;

export default CLOCK_UPDATE_DELAY;
